import '../../pages/TryoutPage.css';

import React from 'react';

import { useNavigate } from 'react-router-dom';

import CopyIcon from '../../components/common/CopyIcon';
import VideoUploadNavIndicator
  from '../../components/common/VideoUploadNavIndicator/VideoUploadNavIndicator';
import {
  ChevronRightIcon,
  ClipboardIcon,
  ExportIcon,
  LeaveIcon,
  MegaphoneIcon,
  PlusIcon,
  RankIcon,
  SettingsIcon,
} from '../../pages/TryoutIcons';
import { copyTextToClipboard } from '../../utils/clipboard';
import { useDemoStore } from '../store/DemoStoreContext';

const DemoTryoutPage: React.FC = () => {
  const navigate = useNavigate();
  const { tryoutMeta, coach } = useDemoStore();
  const [codeCopied, setCodeCopied] = React.useState(false);
  const copyTimeoutRef = React.useRef<number | null>(null);
  const logo = `${process.env.PUBLIC_URL}/logo.svg`;

  const handleCopyCode = (code: string): void => {
    void copyTextToClipboard(code).then(() => {
      setCodeCopied(true);
      if (copyTimeoutRef.current != null) window.clearTimeout(copyTimeoutRef.current);
      copyTimeoutRef.current = window.setTimeout(() => {
        setCodeCopied(false);
        copyTimeoutRef.current = null;
      }, 2000);
    });
  };

  return (
    <div className="tryout-shell">
      <header className="tryout-nav">
        <img src={logo} alt="CheerEval" className="tryout-nav__logo" />
        <div className="tryout-nav__right-col">
          <button
            type="button"
            className="tryout-nav__code-chip"
            onClick={() => handleCopyCode(tryoutMeta.code)}
            aria-label={`Copy tryout code ${tryoutMeta.code}`}
          >
            <span className="tryout-nav__code-label">{codeCopied ? 'Copied!' : 'Code'}</span>
            <span className="tryout-nav__code-value">{tryoutMeta.code}</span>
            <CopyIcon className="tryout-nav__copy-icon" />
          </button>
          <VideoUploadNavIndicator />
        </div>
      </header>

      <div className="tryout-scroll">
        <section className="tryout-section">
          <div className="tryout-context-card">
            {tryoutMeta.gymLogoUrl ? (
              <div className="tryout-context-card__logo-wrap">
                <img
                  src={tryoutMeta.gymLogoUrl}
                  alt={`${tryoutMeta.name} gym logo`}
                  className="tryout-context-card__logo tryout-context-card__logo--visible"
                />
              </div>
            ) : null}
            <div className="tryout-context-card__info">
              <div className="tryout-context-card__tryout-name">{tryoutMeta.name}</div>
              <div className="tryout-context-card__live-badge">Welcome, {coach.name}</div>
            </div>
          </div>
        </section>

        <section className="tryout-section">
          <button
            type="button"
            className="tryout-score-block"
            onClick={() => navigate('/demo/tryout/athletes')}
          >
            <div className="tryout-score-block__header">
              <div className="tryout-score-block__label">
                Evaluate<br />Athletes
              </div>
              <div className="tryout-score-block__icon">
                <ClipboardIcon size={22} />
              </div>
            </div>
            <div className="tryout-score-block__footer">
              <div className="tryout-score-block__arrow">
                <ChevronRightIcon size={20} />
              </div>
            </div>
          </button>
        </section>

        <section className="tryout-section tryout-grid">
          <button
            type="button"
            className="tryout-grid-cell"
            onClick={() => navigate('/demo/tryout/ranking')}
          >
            <div className="tryout-grid-cell__icon">
              <RankIcon size={22} />
            </div>
            <div>
              <div className="tryout-grid-cell__label">Place Athletes</div>
            </div>
          </button>

          <button
            type="button"
            className="tryout-grid-cell"
            onClick={() => navigate('/demo/tryout/add')}
          >
            <div className="tryout-grid-cell__icon">
              <PlusIcon size={22} />
            </div>
            <div>
              <div className="tryout-grid-cell__label">Add Athletes</div>
            </div>
          </button>
        </section>

        <section className="tryout-section tryout-grid">
          <button
            type="button"
            className="tryout-grid-cell"
            onClick={() => navigate('/demo/tryout/announcements')}
          >
            <div className="tryout-grid-cell__icon">
              <MegaphoneIcon size={20} strokeWidth={2} />
            </div>
            <div>
              <div className="tryout-grid-cell__label">Announcements</div>
            </div>
          </button>
          <button
            type="button"
            className="tryout-grid-cell"
            onClick={() => navigate('/demo/tryout/export')}
          >
            <div className="tryout-grid-cell__icon">
              <ExportIcon size={20} strokeWidth={2} />
            </div>
            <div>
              <div className="tryout-grid-cell__label">Export Athletes</div>
            </div>
          </button>

          <button
            type="button"
            className="tryout-grid-cell"
            onClick={() => navigate('/demo/tryout/settings')}
          >
            <div className="tryout-grid-cell__icon">
              <SettingsIcon size={22} strokeWidth={2} />
            </div>
            <div>
              <div className="tryout-grid-cell__label">Settings</div>
            </div>
          </button>
        </section>

        <div className="tryout-leave-row">
          <button
            type="button"
            className="tryout-leave-btn"
            onClick={() => navigate('/')}
          >
            <LeaveIcon size={14} />
            Leave Demo Tryout
          </button>
        </div>
      </div>
    </div>
  );
};

export default DemoTryoutPage;
